import css from 'styled-jsx/css';
import { rgba, isRTL } from 'common/styling/theme';
const staticStyles = css.global`
  /* 修改容器样式为居左 */
  .personal-page-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-height: 300px;
    padding: 50px 60px 0 60px;
    margin: 40px;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    border-radius: 20px;
    border: 1px solid rgba(44, 0, 143, 0.1);
  }

  /* 确保标题居左 */
  .personal-page-container .user-name {
    margin: 0 0 20px 0;
    text-align: left;
    color: #2c008f;
    font-family: 'Samsung Sharp Sans';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  /* 修改提示文本背景覆盖整个右侧屏幕 */
  .verification-prompt {
    background-color: #fcebb3;
    height: 50px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    margin-bottom: 30px;
    border-radius: 10px;
    width: 700px;
  }

  .verification-prompt-span {
    color: #000;
    font-family: 'Samsung Sharp Sans';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    opacity: 1 !important;
    margin-left: 20px;
  }

  /* 进度条整体容器 */
  .verification-container {
    width: 100%;
    box-sizing: border-box;
    height: 290px;
    border-radius: 16px;
    border: 1px solid rgba(44, 0, 143, 0.1);
    background: #fff;
  }

  /* 进度条标题 */
  .verification-title {
    margin: 40px 0 16px 0; /* 移除左侧margin，保持与容器内边距对齐 */
    text-align: left;
    color: #000;
    font-family: 'Samsung Sharp Sans';
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding-left: 60px; /* 添加左侧内边距 */
  }

  /* 进度条包装器 */
  .verification-steps-wrapper {
    width: calc(100% - 60px); /* 调整宽度以匹配容器内边距 */
    margin-top: 60px;
  }

  /* 进度条样式 - 覆盖整个页面 */
  .verification-progress {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    margin-top: 60px;
  }

  /* 修改步骤数字和名称的容器 - 调整为数字居中 */
  /* 步骤数字和名称的容器 - 调整为居中展示 */
  .step-number-container {
    display: flex;
    flex-direction: column;
    align-items: center; /* 修改为center使整个容器内容居中 */
    flex: 1;
    max-width: 200px;
  }

  /* 步骤数字样式 - 保持居中 */
  .step-number {
    width: 36px;
    height: 36px;
    border: 3px solid #4500e2;
    border-radius: 50%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    color: #4500e2;
    margin-bottom: 8px;
    z-index: 1;
    transition: transform 0.3s ease, background-color 0.3s ease;
  }

  .step-number:hover {
    transform: scale(1.2);
    background: linear-gradient(53.07deg, rgba(69, 0, 226, 0.15) 0%, rgba(124, 158, 251, 0.15) 100%);
    color: #4500e2;
    border-color: rgba(69, 0, 226, 0.8);
  }

  .step-number-completed {
    background-color: #4500e2;
    color: #fff;
    border: unset;
  }

  .step-number-completed:hover {
    transform: scale(1.2);
    color: #fff;
    background-color: rgba(69, 0, 226, 0.8);
  }

  .step-number-processing {
    background-color: #f2ba00;
    color: #fff;
    border: unset;
  }

  .step-number-processing:hover {
    transform: scale(1.2);
    color: #fff;
    background-color: rgba(242, 186, 0, 0.8);
  }
  /* 步骤名称链接样式 - 修改为居中对齐 */
  .step-name-link {
    padding: 4px 8px;
    transition: color 0.2s;
    text-align: center; /* 修改为center使文案居中 */
    white-space: nowrap;
    color: #000;
    font-family: 'Red Hat Display';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .step-name-link:hover {
    text-decoration: underline;
    transform: scale(1.2);
  }
  .step-name-link span {
    text-decoration: underline;
  }

  .step-name-link span:hover {
    text-decoration: underline;
  }

  /* 连接线样式 - 调整以匹配居中布局 */
  .step-connector {
    flex: 1;
    height: 1px;
    background-color: rgba(44, 0, 143, 0.2);
    margin: 0 10px;
  }

  /* 进度条样式 - 保持居中布局 */
  .verification-progress {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    padding-left: 20px;
  }

  /* 删除原来的步骤名称容器，因为现在名称直接在数字下方显示 */
  .verification-step-names {
    display: none;
  }

  /* 虚拟账户模块样式 - 修改为与AccountsPage一致 */
  .demo-accounts-container {
    width: 100%;
    margin-top: 40px;
    margin-bottom: 45px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 20px;
    border: 1px solid rgba(44, 0, 143, 0.1);
  }
  .AccountTable {
    margin-right: 50px !important;
  }
  .AccountsBlock {
    margin-bottom: 45px;
    &:last-child {
      margin: 45px 0 0 0;
    }
    padding-left: 60px !important;
  }

  .AccountsBlock h3 {
    color: #000;
    font-family: 'Samsung Sharp Sans';
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .ReactTable .rt-tbody .rt-tr-group {
    border-radius: 8px !important;
    border: 1px solid rgba(0, 0, 0, 0.4) !important;
    background: #fff !important;
    margin-bottom: 10px !important;
  }

  .ReactTable .rt-thead.-header .rt-th span {
    color: #000 !important;
    font-family: 'Red Hat Display' !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: normal !important;
    text-transform: unset !important;
    opacity: 0.6;
  }

  .AccountTable .ReactTable .rt-thead.-header {
    margin-bottom: 10px !important;
  }

  .ReactTable .rt-tbody .rt-tr-group:last-child {
    margin-block-end: 50px !important;
  }

  .AccountsBlock .AccountsBlock__head button,
  .NoAccountsPanel__inner button {
    border-radius: 16px;
    border: 1.5px solid rgba(44, 0, 143, 0.1);
    background: #fff;
    border-radius: 10px;
    border: 1px solid #4500e2;
    height: 50px;
    justify-content: center;
    align-items: center;
    gap: 12px;
  }

  .AccountsBlock .AccountsBlock__head button {
    margin-right: 50px;
  }

  .AccountTable .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td span {
    color: #2c008f !important;
    font-family: 'Red Hat Display' !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    line-height: normal !important;
  }

  .AccountTable .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td .LoginCell__name {
    font-size: 12px !important;
    font-weight: 500 !important;
  }

  // .DefaultButton__text {
  //   color: #4500e2;
  //   font-family: 'Red Hat Display';
  //   font-size: 14px;
  //   font-style: normal;
  //   font-weight: 700;
  //   line-height: normal;
  //   text-transform: capitalize;
  // }

  /* 虚拟账户头部样式 - 修改为与AccountsBlock__head一致 */
  .demo-accounts-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
  }

  .demo-accounts-header h3 {
    position: relative;
    display: inline-block;
    width: auto;
    height: auto;
    padding-right: 25px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .demo-accounts-body {
    width: 100%;
  }

  /* 无账户面板样式 */
  .no-accounts-panel {
    padding: 32px;
    text-align: center;
    background-color: #f5f5f5;
    border-radius: 8px;
  }

  .no-accounts-panel p {
    margin-bottom: 16px;
    color: #666;
  }

  .NoAccountsPanel__inner {
    border: unset !important;
    padding: 5.3rem 1.33333rem;
  }

  .AccountsBlock .NoAccountsPanel__inner h3 {
    color: #000 !important;
    font-family: 'Red Hat Display';
    font-size: 14px !important;
    font-style: normal;
    font-weight: 500 !important;
    line-height: normal;
    opacity: 0.6;
  }

  // .AccountsBlock .NoAccountsPanel__inner button {
  //   display: inline-flex;
  //   height: 50px;
  //   padding: 18px 24px;
  //   justify-content: center;
  //   align-items: center;
  //   gap: 12px;
  //   flex-shrink: 0;
  //   border-radius: 10px;
  //   background: #4500e2;
  // }
  //
  // .AccountsBlock .NoAccountsPanel__inner button span {
  //   color: #fff;
  //   font-family: 'Red Hat Display';
  //   font-size: 14px;
  //   font-style: normal;
  //   font-weight: 700;
  //   line-height: normal;
  //   text-transform: capitalize;
  //   margin-left: 15px;
  // }
  /* 账户列表样式 - 修改为与AccountTable样式更接近 */
  .accounts-list {
    width: 100%;
    border: 1px solid #e9e9e9;
    border-radius: 5px;
    overflow: hidden;
  }

  .account-item {
    padding: 18px;
    background-color: #ffffff;
    border-bottom: 1px solid #e9e9e9;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .account-item:hover {
    background-color: #f8f9fa;
  }

  /* 最后一个账户项移除底边框 */
  .account-item:last-child {
    border-bottom: none;
  }

  .account-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
  }

  .account-login {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .account-platform,
  .account-balance {
    font-size: 14px;
    color: #666;
  }

  /* 响应式调整 - 移动端显示时标题占满宽度 */
  @media (max-width: 768px) {
    .demo-accounts-header h3 {
      width: 100%;
      margin-bottom: 15px;
    }

    .account-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
  }
`;

export { staticStyles };
